import React, { useState } from "react";
import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import Link from "@material-ui/core/Link";
import Box from "@material-ui/core/Box";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Alert from "@material-ui/lab/Alert";
import { withRouter } from "react-router-dom";
import CircularProgress from "@material-ui/core/CircularProgress";
import { invokeApi } from "../../bl_libs/ApiCalling";

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {"Copyright © "}
      <Link color="inherit">LA Moving Star</Link> {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

const useStyles = makeStyles(() => ({
  paper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginTop: "25%",
  },
  avatar: {
    backgroundColor: "#c4314b",
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: "2%",
  },
  submit: {
    marginTop: "3%",
  },
  txt: {
    color: "black",
    marginTop: "4%",
  },
  alert: {
    width: "100%",
  },
}));

function SignIn(props) {
  const classes = useStyles();
  const [username, setusername] = useState("");
  const [password, setpassword] = useState("");
  const [errorflag, setflag] = useState("");
  const [iswaiting, setiswaiting] = useState(false);

  const handlesubmit = (event) => {
    event.preventDefault();
    setiswaiting(true);
    let Data = {
      email: username,
      password: password,
      user_type: "3",
    };
    //console.log(Data);
    let requestObj = {
      path: "/app_api/login",
      method: "POST",
      postData: Data,
    };
    invokeApi(requestObj).then((res) => {
      setiswaiting(true);
      //console.log(res, "RESPONSE");
      if (res.code == 200) {
        setiswaiting(false);
        localStorage.setItem("token", res.data.auth_token);
        props.history.push("/admin");
      } else {
        setiswaiting(false);
        setflag("invalid username or password");
      }
    });
  };
  const handleusername = (event) => {
    setusername(event.target.value);
  };
  const handlepassword = (event) => {
    setpassword(event.target.value);
  };
  if (iswaiting) {
    return (
      <div className="Circular-Progress">
        <CircularProgress color="primary" />
      </div>
    );
  }
  return (
    <>
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <div className={classes.paper}>
          <Avatar className={classes.avatar}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography className={classes.txt} component="h1" variant="h5">
            Sign in
          </Typography>
          {errorflag && (
            <Alert className={classes.alert} severity="error">
              {errorflag}
            </Alert>
          )}
          <form className={classes.form} onSubmit={handlesubmit}>
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              id="email"
              onChange={handleusername}
              label="Email"
              name="email"
              autoFocus
            />
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              onChange={handlepassword}
              name="password"
              label="Password"
              type="password"
              id="password"
              autoComplete="current-password"
            />
            <Button
              size="large"
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              className={classes.submit}
            >
              Sign In
            </Button>
          </form>
        </div>
        <Box mt={8}>
          <Copyright />
        </Box>
      </Container>
    </>
  );
}
export default withRouter(SignIn);
